// extracted by mini-css-extract-plugin
export var divider = "_pm-0";
export var systemMessage = "_pm-1";
export var systemMessageWrapper = "_pm-2";